import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Modal } from 'antd';

import Alert from 'components/Alert/Alert';
import HTMLText from 'components/HTMLText/HTMLText';
import InterviewScheduler from 'components/InterviewScheduler/InterviewScheduler';

import { InterviewSlotSerialized } from 'types/interviewSlots';

import { AlertType } from 'constants/enums';

import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';

import styles from './InterviewSchedulerModal.module.scss';

const MODAL_WIDTH = 1200;

interface InterviewSchedulerModalProps {
  isOpen: boolean;
  proposedSlots?: InterviewSlotSerialized[];
  onClose: () => void;
  jobseekerName?: string | null | undefined;
}

const InterviewSchedulerModal: FC<InterviewSchedulerModalProps> = ({
  isOpen,
  proposedSlots,
  onClose,
  jobseekerName
}) => {
  const { t } = useTranslation();

  const jobName = jobseekerName ?? t('modal.interviewScheduler.name');
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={MODAL_WIDTH}
      destroyOnHidden
      closeIcon={<CloseIcon />}
      title={t('modal.interviewScheduler.title')}
      centered
      rootClassName={styles.modalRoot}
    >
      <Alert type={AlertType.Info} className={styles.infoMessageContainer}>
        <HTMLText
          text={t('modal.interviewScheduler.message', { job: jobName })}
        />
      </Alert>
      <InterviewScheduler proposedSlots={proposedSlots} onConfirm={onClose} />
    </Modal>
  );
};

export default InterviewSchedulerModal;
